import type { TypePolicy } from '@apollo/client';
import type { Share } from '../../../generated';
import type { TypePolicies } from '../../../utils/types/TypePolicies';

const KEY_NAME = 'Share';

export const typePolicies: TypePolicies = {
  /**
   * @note Defines a single Apollo cache key for all implementations of the
   * `Share` interface.
   */
  Share: {
    keyFields: makeCacheKey<Share>(KEY_NAME),
  },
  Query: {
    fields: {
      share: {
        read: (_, { toReference, args }) =>
          toReference({
            __typename: 'Share',
            id: args?.shareId ?? args?.by?.shareId,
          }),
      },
    },
  },
};

function makeCacheKey<R extends CacheableRecord = any>(
  cacheKeyPrefix: string
): KeyFieldFunction {
  return ({ id }: R) => [cacheKeyPrefix, id].join(':');
}

type KeyFieldFunction = Extract<TypePolicy['keyFields'], (...args: any) => any>;
type CacheableRecord = { id: string } & Record<string, unknown>;
